<template>
    <div class="flex justify-center shadow appearance-none border border-red-500 rounded p-1 w-8" ref="colorpicker">
        <span class="current-color m-auto" :style="'background-color: ' + value" @click="togglePicker()"></span>
        <color-picker :value="colors" style="position: absolute;z-index: 9;" @input="updateFromPicker" v-if="displayPicker" />
    </div>
</template>

<style>
    .current-color {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-color: #000;
        cursor: pointer;
    }
</style>

<script>

    import { Chrome } from 'vue-color';

    export default {
        components: {
            'color-picker': Chrome,
        },
        props: ['value'],
        data() {
            return {
                colors: {
                    hex: this.value
                },
                displayPicker: false,
                colorValue: this.value,
            };
        },
        methods: {
            updateFromPicker(color) {
                this.$emit('input', color.hex);
                this.colorValue = color.hex;
                this.colors = color;
            },
            togglePicker() {
                this.displayPicker ? this.hidePicker() : this.showPicker();
            },
            documentClick(e) {
                const el = this.$refs.colorpicker,
                    target = e.target;

                if(el !== target && !el.contains(target)) {
                    this.hidePicker()
                }
            },
            showPicker() {
                document.addEventListener('click', this.documentClick);
                this.displayPicker = true;
            },
            hidePicker() {
                document.removeEventListener('click', this.documentClick);
                this.displayPicker = false;
            },
        }
    }
</script>
